import Module from "utilities/global/sparta-module-utility/6.2.5/js/sparta-module-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.2/js/ah-caw-events-master-utility";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import spartaTemplates from "modules/login/ah-page-title-module/7.0.1/js/templates";
import "css!modules/login/ah-page-title-module/7.0.1/css/ah-page-title-module.scss.css";










export default class ahPageTitleModuleJS extends Module {
    constructor(options) {
        super(options);

    }

    init(args = {}) {
        this.Events.sub(cawEventsMasterUtility.EVENTS.SHOW_WIDGET_HEADER, () => {
            $(this.settings.$target).find('#ahPageTitleContainer').removeClass('hidden');
        });
    }
}
